module.exports = __webpack_public_path__ + "static/media/20200113_161618.744cb395.jpg";